/** @prettier */
// @flow
import React from 'react';

import type { FiveSymbolLocale } from '#common/utils/locale';

import cartIcon from '../../../../assets/images/icons/cart.svg';
import { getHeaderStoreButtonText } from '../../../../utils/translation';
import './style.pcss';

type Props = {|
  onClick: () => void,
  locale: FiveSymbolLocale,
  count?: number,
  hideText?: boolean,
|};

export const CartButton = ({
  onClick,
  locale,
  count = 0,
  hideText = false,
}: Props) => (
  <button className='header-cart-button' onClick={onClick}>
    <span
      className='header-cart-button__icon'
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: cartIcon }}
    />
    {!!count && <span className='header-cart-button__icon-count'>{count}</span>}
    {!hideText && (
      <span className='header-cart-button__text'>
        {getHeaderStoreButtonText(locale)}
      </span>
    )}
  </button>
);
